import api from "@/plugins/api";
// Sibling of `/organisations/settings` (OPUS legal info) — same page, OPDON upstream.
const ENDPOINT = "/organisations/settings/rfm";
const OPTIONS = { unwrapEnvelope: true };
export async function getRfmSettings() {
    const response = await api.get(ENDPOINT, OPTIONS);
    return response.data;
}
export async function updateRfmSettings(payload) {
    const response = await api.put(ENDPOINT, payload, OPTIONS);
    return response.data;
}
